import { CarsType } from '@/typings/common';

export const stepLabelsMap: Record<CarsType, Array<string>> = {
  new: ['Адрес и время', 'Контактные данные'],
  amp: ['Место и время', 'Контактные данные'],
};
